module.exports = __webpack_public_path__ + "img/guara1.158fd427.png";